document.addEventListener('turbo:load', function() {
  $('#two-minute-drill-top-form #add-cday-button').click(function () {
    const lastChild = $('#cday-fields').children().last();
    if (lastChild.hasClass('d-none')) lastChild.removeClass('d-none');
    else {
      const clone = $('#cday-fields').children().last().clone();
      clone.appendTo('#cday-fields');
    }
    $('#save-cdays-button').removeClass('d-none');
  });

  $('#two-minute-drill-top-form .delete-upcoming-cday-button').click(function() {
    if (!confirm('Are you sure you want to delete this Confirmation Day?')) return;

    const hsBrandId = $(this).attr('hs_brand_id');
    const confirmationDayId = $(this).attr('confirmation_day_id');
    const tr = $(this).closest('tr');
    const data = {
      confirmation_day_id: confirmationDayId
    };
    $.ajax({
      url: `/brands/${hsBrandId}/delete_cday`,
      method: 'delete',
      data: data
    }).always(function(data) {
      if (data['success']) tr.remove();
      else alert(`There was an issue removing this Confirmation Day. Let us know if this issue persists. ID: ${confirmationDayId}`)
    });
  });
});